"use client";

import { useMediaQuery } from "react-responsive";

/**
 * 响应式断点 Hook
 * 提供 Tailwind CSS 标准的断点检测
 * @returns 包含各个断点状态的对象
 */
export function useBreakpoints() {
  const is2xl = useMediaQuery({ minWidth: 1536 });
  const isXl = useMediaQuery({ minWidth: 1280, maxWidth: 1535 });
  const isLg = useMediaQuery({ minWidth: 1024, maxWidth: 1279 });
  const isMd = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const isSm = useMediaQuery({ minWidth: 640, maxWidth: 767 });

  return {
    is2xl,
    isXl,
    isLg,
    isMd,
    isSm,
  };
}
